"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ReplicationRuleFilter_1 = require("./_ReplicationRuleFilter");
var _SourceSelectionCriteria_1 = require("./_SourceSelectionCriteria");
var _Destination_1 = require("./_Destination");
var _DeleteMarkerReplication_1 = require("./_DeleteMarkerReplication");
exports._ReplicationRule = {
    type: "structure",
    required: ["Status", "Destination"],
    members: {
        ID: {
            shape: {
                type: "string"
            }
        },
        Priority: {
            shape: {
                type: "integer"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Filter: {
            shape: _ReplicationRuleFilter_1._ReplicationRuleFilter
        },
        Status: {
            shape: {
                type: "string"
            }
        },
        SourceSelectionCriteria: {
            shape: _SourceSelectionCriteria_1._SourceSelectionCriteria
        },
        Destination: {
            shape: _Destination_1._Destination
        },
        DeleteMarkerReplication: {
            shape: _DeleteMarkerReplication_1._DeleteMarkerReplication
        }
    }
};
//# sourceMappingURL=_ReplicationRule.js.map